import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./css/product.css";
import { Product } from "./pages/Product";
import store from "./stores/product/product.store";
import { Provider } from "react-redux";

const container = document.getElementById('product');

if (container) {
    hydrateRoot(
        container,
        <Provider store={store}>
            <Product />
        </Provider>
    );
} else {
    console.error('Failed to find the root element for hydrating.');
}